import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload/index";
import LivestreamBackground from "../LivestreamBackground";
import cn from "classnames";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {logoIconWhite} from "../../../data/constants";

// 1080×1920 — Instagram Stories livestream card (Figma 4289:2116).
// Header + logo, title, speaker + date, photo zone.
const LivestreamStories = ({id, zoom}) => {
  const {titles, names, names2, names3, names4, names5, names6, positions, positions2, dates, times} =
    useEdits();
  const {layoutOption, titleFontSize} = useSetting();
  const isL1 = Number(layoutOption) === 1;
  const isL2 = Number(layoutOption) === 2;
  const isL3 = Number(layoutOption) === 3;
  const isL4 = Number(layoutOption) === 4;
  const isL5 = Number(layoutOption) === 5;
  const isL6 = Number(layoutOption) === 6;
  const isL7 = Number(layoutOption) === 7;
  const title = titles[id] || titles.main;
  const name = names[id] || names.main;
  const position = positions[id] || positions.main;
  const name2 = names2[id] || names2.main;
  const name3 = names3[id] || names3.main;
  const name4 = names4[id] || names4.main;
  const name5 = names5[id] || names5.main;
  const name6 = names6[id] || names6.main;
  const position2 = positions2[id] || positions2.main;
  const date = dates[id] || dates.main;
  const time = times[id] || times.main;

  return (
    <div
      id={id}
      className={`template livestream livestream-tpl layout-${layoutOption}`}
      style={{"--zoom-level": zoom}}
    >
      <div className="livestream-tpl__inner">
        <LivestreamBackground id={id} />

        <div className="content">
          {isL1 || (isL2 && <header className="ls-header">JetBrains | Livestream</header>)}

          <div className="ls-main">
            <h1 className={cn("title", {"title--small": titleFontSize === "small"})}>
              <Textarea id={id} text={title} />
            </h1>
          </div>

          {isL7 ? (
            // layout-7: six speakers, name only, each below its photo.
            <>
              <div className="ls-speaker">
                <h2 className="name">
                  <Textarea id={id} text={name} />
                </h2>
              </div>
              <div className="ls-speaker-2">
                <h2 className="name2">
                  <Textarea id={id} text={name2} />
                </h2>
              </div>
              <div className="ls-speaker-3">
                <h2 className="name3">
                  <Textarea id={id} text={name3} />
                </h2>
              </div>
              <div className="ls-speaker-4">
                <h2 className="name4">
                  <Textarea id={id} text={name4} />
                </h2>
              </div>
              <div className="ls-speaker-5">
                <h2 className="name5">
                  <Textarea id={id} text={name5} />
                </h2>
              </div>
              <div className="ls-speaker-6">
                <h2 className="name6">
                  <Textarea id={id} text={name6} />
                </h2>
              </div>
            </>
          ) : isL6 ? (
            // layout-6: five speakers, name only, each below its photo.
            <>
              <div className="ls-speaker">
                <h2 className="name">
                  <Textarea id={id} text={name} />
                </h2>
              </div>
              <div className="ls-speaker-2">
                <h2 className="name2">
                  <Textarea id={id} text={name2} />
                </h2>
              </div>
              <div className="ls-speaker-3">
                <h2 className="name3">
                  <Textarea id={id} text={name3} />
                </h2>
              </div>
              <div className="ls-speaker-4">
                <h2 className="name4">
                  <Textarea id={id} text={name4} />
                </h2>
              </div>
              <div className="ls-speaker-5">
                <h2 className="name5">
                  <Textarea id={id} text={name5} />
                </h2>
              </div>
            </>
          ) : isL5 ? (
            // layout-5: four speakers, name only, each below its photo.
            <>
              <div className="ls-speaker">
                <h2 className="name">
                  <Textarea id={id} text={name} />
                </h2>
              </div>
              <div className="ls-speaker-2">
                <h2 className="name2">
                  <Textarea id={id} text={name2} />
                </h2>
              </div>
              <div className="ls-speaker-3">
                <h2 className="name3">
                  <Textarea id={id} text={name3} />
                </h2>
              </div>
              <div className="ls-speaker-4">
                <h2 className="name4">
                  <Textarea id={id} text={name4} />
                </h2>
              </div>
            </>
          ) : isL4 ? (
            // layout-4: three speakers, name only (no job titles), each below
            // its photo.
            <>
              <div className="ls-speaker">
                <h2 className="name">
                  <Textarea id={id} text={name} />
                </h2>
              </div>
              <div className="ls-speaker-2">
                <h2 className="name2">
                  <Textarea id={id} text={name2} />
                </h2>
              </div>
              <div className="ls-speaker-3">
                <h2 className="name3">
                  <Textarea id={id} text={name3} />
                </h2>
              </div>
            </>
          ) : (
            <>
              <div className="ls-speaker">
                <h2 className="name">
                  <Textarea id={id} text={name} />
                </h2>
                <h2 className="position">
                  <Textarea id={id} text={position} />
                </h2>
              </div>

              {isL3 && (
                <div className="ls-speaker-2">
                  <h2 className="name2">
                    <Textarea id={id} text={name2} />
                  </h2>
                  <h2 className="position2">
                    <Textarea id={id} text={position2} />
                  </h2>
                </div>
              )}
            </>
          )}

          <div className="date">
            <Textarea id={id} text={date} />
          </div>

          <div className="time">
            <Textarea id={id} text={time} />
          </div>
        </div>

        {isL3 || isL4 || isL5 || isL6 || isL7 ? (
          <>
            <div className="upload-wrap upload-a">
              <ImageUpload
                id="ls-speaker-1"
                imageKey="ls-speaker-1"
                transformKey={`${id}-ls-speaker-1`}
              />
            </div>
            <div className="upload-wrap upload-b">
              <ImageUpload
                id="ls-speaker-2"
                imageKey="ls-speaker-2"
                transformKey={`${id}-ls-speaker-2`}
              />
            </div>
            {(isL4 || isL5 || isL6 || isL7) && (
              <div className="upload-wrap upload-c">
                <ImageUpload
                  id="ls-speaker-3"
                  imageKey="ls-speaker-3"
                  transformKey={`${id}-ls-speaker-3`}
                />
              </div>
            )}
            {(isL5 || isL6 || isL7) && (
              <div className="upload-wrap upload-d">
                <ImageUpload
                  id="ls-speaker-4"
                  imageKey="ls-speaker-4"
                  transformKey={`${id}-ls-speaker-4`}
                />
              </div>
            )}
            {(isL6 || isL7) && (
              <div className="upload-wrap upload-e">
                <ImageUpload
                  id="ls-speaker-5"
                  imageKey="ls-speaker-5"
                  transformKey={`${id}-ls-speaker-5`}
                />
              </div>
            )}
            {isL7 && (
              <div className="upload-wrap upload-f">
                <ImageUpload
                  id="ls-speaker-6"
                  imageKey="ls-speaker-6"
                  transformKey={`${id}-ls-speaker-6`}
                />
              </div>
            )}
          </>
        ) : (
          <div className="upload-wrap">
            <ImageUpload id={id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LivestreamStories;
